<iframe style="width: 100%;height: 100vh;" src="https://app.powerbi.com/view?r=eyJrIjoiMWYwNjI5ZmUtMWJmNi00YjQ2LThhZjEtMTFjOTcxZDRhMmVlIiwidCI6IjUxNjNjZDcwLWE0MjEtNDUyOC1hN2VmLWE1MmYyYTcxNmYwOSJ9" frameborder="0"></iframe>
